import React, { FC, useEffect } from 'react';
import { Navigate } from 'react-router';

import { Spinner } from 'src/components/spinner';
import { useCustomerInfoQuery } from 'src/hooks/use-customer-info-query';
import { ChooseServiceLocationPageContent } from 'src/pages/choose-service-location/choose-service-location-page-content';
import { NavigationService } from 'src/services/navigation-service';
import { selectServiceLocationActionCreator } from 'src/state/address/action-creators/select-address-action-creator';
import { selectServiceLocation } from 'src/state/address/selectors';
import { goToStepActionCreator } from 'src/state/order/action-creators/go-to-step-action-creator';
import { OrderStep } from 'src/state/order/types';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { withOrderStep } from 'src/hocs/with-order-step';

export const ChooseServiceLocationPageComponent: FC = () => {
  const dispatch = useAppDispatch();
  const selectedServiceLocation = useAppSelector(selectServiceLocation);
  const { userInfo, isLoading } = useCustomerInfoQuery();
  const hasOnlyOneServiceLocation = !!userInfo?.serviceLocations && userInfo.serviceLocations.length === 1;

  useEffect(() => {
    if (hasOnlyOneServiceLocation) {
      if (!selectedServiceLocation) {
        dispatch(selectServiceLocationActionCreator(userInfo.serviceLocations[0]));
      }
      dispatch(goToStepActionCreator(OrderStep.PRODUCT_SELECT, true));
    }
  }, [dispatch, hasOnlyOneServiceLocation, selectedServiceLocation, userInfo]);

  if (isLoading || hasOnlyOneServiceLocation) {
    return <Spinner />;
  }

  if (!userInfo) {
    return <Navigate to={NavigationService.ERROR} replace={true} />;
  }

  if (userInfo.userDetails.crmSystem !== 'R6') {
    return <Navigate to={NavigationService.ERROR_NOT_AVAILABLE} replace={true} />;
  }

  if (userInfo.serviceLocations.length === 0) {
    return <Navigate to={NavigationService.ERROR_NO_SERVICE_LOCATIONS} replace={true} />;
  }

  return <ChooseServiceLocationPageContent serviceLocations={userInfo.serviceLocations} />;
};

export const ChooseServiceLocationPage = withOrderStep(OrderStep.CHOOSE_SERVICE_LOCATION)(
  ChooseServiceLocationPageComponent,
);
